// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"203":"32b0f53a","409":"834bf080"}[chunkId] + ".chunk.js";
};